import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const DriverSelect = ({ load, drivers, onChange, onOpenChange, testId, className = "" }) => {
  const current = load.assigned_driver_id;
  const archived = current && !drivers.some((d) => d.user_id === current);
  return (
    <Select
      value={current || "none"}
      onValueChange={(v) => onChange(v === "none" ? null : v)}
      onOpenChange={onOpenChange}
    >
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder="Unassigned" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Unassigned</SelectItem>
        {archived && (
          <SelectItem value={current} disabled>{load.driver_name || "Archived driver"} (archived)</SelectItem>
        )}
        {drivers.map((d) => (
          <SelectItem key={d.user_id} value={d.user_id}>{d.name || d.email}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
